window.addEventListener('load', () => {
	const watcher = document.getElementById('scrollWatch');
	const supportsScrollTimeline =
		window.CSS && window.CSS.supports('animation-timeline: scroll()');

	if (watcher && !supportsScrollTimeline) {
		// Fallback for browsers that do not support CSS scroll-driven animations.
		const updateScrollWatcher = () => {
			const scrollTop = window.scrollY;
			const scrollHeight =
				document.documentElement.scrollHeight - window.innerHeight;
			const progress = scrollHeight > 0 ? scrollTop / scrollHeight : 0;

			watcher.style.transform = `scaleX(${progress})`;
		};

		// Set the initial state after layout is ready, then keep it in sync.
		window.requestAnimationFrame(updateScrollWatcher);
		window.addEventListener('scroll', updateScrollWatcher, {
			passive: true,
		});
		window.addEventListener('resize', updateScrollWatcher);
	}
});
